<template>
  <div class="benefit-card-split-block">
    <div class="benefit-card-split__left">
      <span class="benefit-card-split-breadcrumb"><router-link :to="`../beneficios/`"
          :data-name="`../beneficios/`">Beneficios Lulo ></router-link> {{ breadcrumb }}</span>
      <benefit-filters-list :segment="segment" :card-type="cardType" />

      <h1 class="benefit-card-split-title">{{ title }}</h1>
      <p class="benefit-card-split-description">{{ description }}</p>

      <ul class="benefit-card-split-info-list">
        <li class="benefit-card-split-info-item">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40">
            <path stroke="#344061" stroke-linecap="round" stroke-width="3"
              d="M26.7 11.7a6.7 6.7 0 1 1-13.4 0 6.7 6.7 0 0 1 13.4 0ZM31.7 31.7c0-4.6-3.8-8.4-8.4-8.4h-6.6a8.3 8.3 0 0 0-8.4 8.4V35h23.4z" />
          </svg>
          <span>
            {{ segment === 'Lulo' ? 'Para todos los usuarios Lulo.' : 'Beneficio exclusivo Lulo Pro.' }}
          </span>
        </li>

        <li v-if="validDate" class="benefit-card-split-info-item">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40">
            <path stroke="#344061" stroke-linecap="square" stroke-linejoin="round" stroke-width="3"
              d="M20 22.5h0m0 6.7h0m6.7-6.7h0m-13.4 0h0m0 6.7h0" />
            <path stroke="#344061" stroke-linejoin="round" stroke-width="3"
              d="M29.2 3.3V10M10.8 3.3V10M35 6.7H5v30h30z" />
            <path stroke="#344061" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 15h30" />
          </svg>
          <span>{{ validDate }}</span>
        </li>

        <li v-if="termsAndConditions" class="benefit-card-split-info-item">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40">
            <path fill="#344061" d="M19.5 10.6a2.3 2.3 0 1 1 0 4.6 2.3 2.3 0 0 1 0-4.6M21.2 18.7v11H18v-11z" />
            <path fill="#344061" fill-rule="evenodd"
              d="M2 20.5a17.5 17.5 0 1 0 35 0 17.5 17.5 0 0 0-35 0m17.5 14.4a14.4 14.4 0 1 1 0-28.8 14.4 14.4 0 0 1 0 28.8"
              clip-rule="evenodd" />
          </svg>
          <a v-if="!getInternalLink(termsAndConditions.button_url)" :href="termsAndConditions.button_url"
            class="benefit-card-split-info-item-link"><span>{{ termsAndConditions.button_text }}</span></a>
          <router-link v-else :to="termsAndConditions.button_url" class="benefit-card-split-info-item-link"><span>{{
            termsAndConditions.button_text }}</span></router-link>
        </li>
      </ul>

      <div v-if="benefitLink" class="button-box">
        <a v-if="!getInternalLink(benefitLink.button_url)" :href="benefitLink.button_url" class="cta"><span>{{
          benefitLink.button_text }}</span></a>
        <router-link v-else :to="benefitLink.button_url" class="cta"><span>{{ benefitLink.button_text
        }}</span></router-link>
      </div>

      <p class="benefit-card-split-disclaimer">
        {{ disclaimer }}
      </p>
    </div>
    <div class="benefit-card-split__right">
      <img v-if="coverImage" :src="coverImage" :alt="'imagen principal beneficio Lulo - Lulo Pro'"
        class="benefit-card-split-main-image" />
      <benefit-logo-badges :logoImage="logoImage.data" large/>
    </div>
  </div>
</template>

<script>
import SectionMixin from '@/mixins/sectionMixin'

import benefitLogoBadges from '@/components/benefit/benefit-logo-badges';
import benefitFiltersList from '@/components/benefit/benefit-filters-list';

export default {
  name: 'benefit-card-split',
  mixins: [SectionMixin],
  components: {
    benefitLogoBadges,
    benefitFiltersList
  },
  props: {
    breadcrumb: String,
    title: String,
    description: String,

    segment: String,
    validDate: String,
    termsAndConditions: Object,
    benefitLink: Object,
    disclaimer: String,

    cardType: {
      type: Array,
      default: () => []
    },
    coverImage: String,
    logoImage: []
  }
}
</script>

<style lang="less" scoped>
@import "../../../styles/vars.less";

.benefit-card-split-block {
  position: relative;
  display: grid;
  grid-auto-flow: column;
  align-content: center;
  grid-template-columns: 60% auto;
  max-width: 1600px;
  margin: 0 auto;
  border-radius: 0 0 30px 30px;
  overflow: hidden;

  padding-top: 100px;
  background: @grey;

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    background: @grey;
  }
}

.benefit-card-split__left {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 60px 100px;
  margin: 0;
}

.benefit-card-split__right {
  position: relative;
  min-height: 350px;
  background-color: @grey;

  .benefit-card-split-main-image {
    position: relative;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: right bottom;
  }
}

.benefit-card-split-breadcrumb {
  display: inline-block;
  font-family: @bold;
  margin-bottom: 40px;
}

.benefit-card-split-title {
  font-family: @bold;
  font-size: 2.5rem;
  padding-bottom: 16px;
}

.benefit-card-split-description {
  font-size: 1.25rem;
  line-height: 30px;
  margin-bottom: 24px;
}

.benefit-card-split-info-item {
  display: flex;
  align-items: center;
  gap: 20px;
  font-size: 1.125rem;
  padding: 22px 0;
}

.benefit-card-split-info-item-link{
  text-decoration: underline;
}

.button-box {
  z-index: 1;
  margin: 32px 0 40px;
}

.benefit-card-split-disclaimer {
  font-size: 0.875rem;
  color: @blue-lighter;
  line-height: 30px;
}

@media screen and (max-width: 1920px) {
  .benefit-card-split-block {
    grid-template-columns: 66% auto;
  }
}

@media screen and (max-width: @desktop) {
  .benefit-card-split-block {
    grid-template-columns: 1fr 1fr;
    border-radius: 0;
  }
}

@media screen and (max-width: @laptop) {
  .benefit-card-split-block {
    padding-top: 80px;
  }
}

@media screen and (max-width: @tablet) {
  .benefit-card-split-block {
    padding-top: 56px;
    grid-auto-flow: row;
    grid-template-columns: 1fr;
  }

  .benefit-card-split__left {
    padding: 32px 24px;
    max-width: 650px;
    margin: 0 auto;
  }

  .benefit-card-split-main-image {
    min-height: fit-content;
  }

  .benefit-card-split-info-item {
    font-size: 1rem;
  }

  .button-box {
    margin: 22px 0 32px;
    width: fit-content;
  }

  .benefit-card-split-disclaimer {
    line-height: 26px;
  }
}
</style>